module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_Foamcore_MockedUp.1d055a8b.jpg";